
<template>
    <div>
        <div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.ScaleSettings')}}</span></el-col>
        </div>
        
        <div class="heiSetting">
            <span class="left">{{$t('main.ExtremeValueLabel')}}</span>
            <div class="right">
                <el-select 
                    size="mini" 
                    style="width: 85px;" 
                    v-model="activeQuestion.extremumTag" 
                    :placeholder="$t('main.PleaseSelect')"
                    @change="extremumTagChange"
                >
                    <el-option 
                        v-for="(item, index) in extremumTagList" 
                        :key="index" 
                        :label="item.label" 
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div class="heiSetting" v-if="activeQuestion.extremumTag == 8" style="width: 90%; margin: 0 auto">
            <div class="custom-tab-box">

                <el-input 
                    v-model="custom.leftTag" 
                    :maxlength="25" 
                    :placeholder="$t('main.CustomContent')" 
                    size="mini"
                    @blur="leftTagBlur"
                ></el-input>
                <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                <el-input 
                    v-model="custom.rightTag" 
                    :maxlength="25" 
                    :placeholder="$t('main.CustomContent')" 
                    size="mini"
                    @blur="rightTagBlur"
                ></el-input>
            </div>
        </div>
        <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">{{$t('main.ScaleSetting')}}</span>
            <div class="right">
                <el-select 
                    size="mini" 
                    style="width: 85px;" 
                    v-model="activeQuestion.orderSetting" 
                    :placeholder="$t('main.PleaseSelect')"
                >
                    <el-option 
                        v-for="(item, index) in 10" 
                        :key="index" 
                        :label="`${item + 1}${$t('main.Level')}`" 
                        :value="item + 1"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div class="heiSetting" style="width: 90%; margin: 0 auto">
            <span class="left">{{$t('main.StartingValue')}}</span>
            <div class="right">
                <PopoverNum
                    :value="activeQuestion.startNum"
                    :size="'mini'"
                    :min="-9"
                    :max="89"
                    :maxlength="2"
                    :controls="false"
                    :content="$t('main.PleaseEnterAValueWithinMax89')"
                    @valueChange="(val) => activeQuestion.startNum = val"
                >
                </PopoverNum>
            </div>
        </div>
        <div class="showStyle" style="width: 90%; margin: 0 auto">
            <span class="left">{{$t('main.DisplayStyle')}}</span>
            <div class="right">
                <div class="showImg" @click="showRateImg = !showRateImg"><img :src="imgUrlData.imgUrl" alt="" /></div>
                <ul class="showUl" v-show="showRateImg">
                    <li v-for="item in rateData" :key="item.id" @click="setShowImg(item.id)"><img :src="item.bgImg" alt="" /></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import PopoverNum from "@/components/myComponents/popoverNum.vue"
export default {
    name: 'ScaleSet', // 量表题属性设置
    components: {
        PopoverNum
    },
    props: {
        activeQuestion: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return{
            extremumTagList: [
                {
                    value: 1,
                    label: this.$t('main.Satisfaction')
                },{
                    value: 2,
                    label: this.$t('main.Identity')
                },{
                    value: 3,
                    label: this.$t('main.Willingness')
                },{
                    value: 4,
                    label: this.$t('main.Importance')
                },{
                    value: 5,
                    label: this.$t('main.Conformance')
                },{
                    value: 6,
                    label: this.$t('main.Perception')
                },{
                    value: 7,
                    label: this.$t('main.Feasibility')
                },{
                    value: 8,
                    label: this.$t('main.Custom')
                }
            ],
            custom: {
                leftTag: '',
                rightTag: ''
            },
            rateData: [
				{
					bgImg: require('@/assets/rate/number.png'),
					value: 'number',
                    id: 0
				},
				{
					bgImg: require('@/assets/rate/stars.png'),
					value: 'star',
                    id: 1
				},
				{
					bgImg: require('@/assets/rate/heart.png'),
					value: 'heart',
                    id: 2
				},
				{
					bgImg: require('@/assets/rate/smile.png'),
					value: 'smile',
                    id: 3
				},
				{
					bgImg: require('@/assets/rate/good.png'),
					value: 'thumb',
                    id: 4
				}
			],
			imgUrlData: {
				imgUrl: require('@/assets/rate/stars.png'),
				value: 'star'
			},
			showRateImg: false,
        }
    },
    created() {
        // console.log('this.activeQuestion')
        // console.log(this.activeQuestion)
        this.setShowImg(this.activeQuestion.displayStyle)
    },
    methods: {
        extremumTagChange(e){
            switch(e) {
                case 1: 
                    this.activeQuestion.leftText = this.$t('main.VeryDissatisfied')
                    this.activeQuestion.rightText = this.$t('main.VerySatisfied')
                    break
                case 2: 
                    this.activeQuestion.leftText = this.$t('main.StronglyDisagree')
                    this.activeQuestion.rightText = this.$t('main.StronglyAgree')
                    break
                case 3: 
                    this.activeQuestion.leftText = this.$t('main.VeryReluctant')
                    this.activeQuestion.rightText = this.$t('main.VeryWilling')
                    break
                case 4: 
                    this.activeQuestion.leftText = this.$t('main.VeryUnimportant')
                    this.activeQuestion.rightText = this.$t('main.VeryImportant')
                    break
                case 5: 
                    this.activeQuestion.leftText = this.$t('main.VeryInconsistent')
                    this.activeQuestion.rightText = this.$t('main.VeryConsistent')
                    break
                case 6: 
                    this.activeQuestion.leftText = this.$t('main.Senseless')
                    this.activeQuestion.rightText = this.$t('main.VeryStrong')
                    break
                case 7: 
                    this.activeQuestion.leftText = this.$t('main.Impossible')
                    this.activeQuestion.rightText = this.$t('main.InAllLikelihood')
                    break
                case 8: 
                    this.activeQuestion.leftText = this.$t('main.CustomContent')
                    this.activeQuestion.rightText = this.$t('main.CustomContent')
                    this.custom = {
                        leftTag: '',
                        rightTag: ''
                    }
                    break
            }
        },
        leftTagBlur(e) {
            console.log(e)
            this.activeQuestion.leftText = e.target.value
        },
        rightTagBlur(e) {
            this.activeQuestion.rightText = e.target.value
        },
        setShowImg(value) {
			this.activeQuestion.displayStyle = value
			this.imgUrlData.imgUrl = this.rateData[value].bgImg;
			this.showRateImgs = false
        }
    }
} 
</script>

<style scoped lang="scss">
.heiSetting{
    width: 90%; 
    margin: 0 auto;
}
.custom-tab-box{
    display: flex;
    align-items: center;
}
</style>